import React, { FC } from 'react';

import { Box, BoxProps, Tooltip, TooltipProps } from '@chakra-ui/react';

import { tooltipProps } from 'components/DataEntry/Button/styles';

export interface CustomTooltipStyles {
  tooltip?: Omit<TooltipProps, 'children'>;
  text?: BoxProps;
}

export interface CustomTooltipProps extends TooltipProps {
  styles?: CustomTooltipStyles;
}

export const CustomTooltip: FC<CustomTooltipProps> = props => {
  const { children, styles, ...rest } = props;
  return (
    <Tooltip {...tooltipProps} {...styles?.tooltip} {...rest}>
      <Box overflow="hidden" textOverflow="ellipsis" {...styles?.text}>
        {children}
      </Box>
    </Tooltip>
  );
};
